import axios from "axios";
import React, { useEffect, useState } from "react";
import endPoint from "../../websitecomponents/redux/EndPoint/endpoint";
import { toast } from "react-toastify";

const ResellerWallet = () => {
  const [walletData, setWalletData] = useState({
    currentBalance: 0,
    totalCredits: 0,
    totalDebits: 0,
    transactions: [],
  });

  const [loading, setLoading] = useState(false);
  const [showWithdrawModal, setShowWithdrawModal] = useState(false);
  const [withdrawAmount, setWithdrawAmount] = useState("");
  const [withdrawLoading, setWithdrawLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    fetchWalletData();
  }, []);

  const fetchWalletData = async () => {
    try {
      setLoading(true);

      const res = await axios.get(endPoint.GetResellerWallet, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("ResellerTokenData")}`,
        },
      });

      setWalletData(res.data);
    } catch (error) {
      toast.error("Failed to load wallet");
    } finally {
      setLoading(false);
    }
  };

  const handleWithdrawSubmit = async () => {
    setError("");

    if (!withdrawAmount || withdrawAmount <= 0) {
      setError("Enter valid amount");
      return;
    }

    if (withdrawAmount > walletData.currentBalance) {
      setError("Amount exceeds balance");
      return;
    }

    try {
      setWithdrawLoading(true);

      await axios.post(
        endPoint.ResellerWithdraw,
        { amount: Number(withdrawAmount) },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("ResellerTokenData")}`,
          },
        },
      );

      toast.success("Withdraw request submitted");
      setShowWithdrawModal(false);
      setWithdrawAmount("");
      fetchWalletData();
    } catch (error) {
      setError(error?.response?.data?.message || "Withdraw failed");
    } finally {
      setWithdrawLoading(false);
    }
  };

  if (loading)
    return <div className="p-10 text-center text-gray-600">Loading wallet...</div>;

  return (
    <div className="min-h-screen  p-6">
      {/* CARDS */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6">
        {/* BALANCE */}
        <div className="  bg-white text-gray-500 p-6 rounded-xl shadow-lg">
          <p className="text-md opacity-80">Available Balance</p>
          <h2 className="text-blue-500 text-2xl font-bold mt-2">
            ₹{walletData.currentBalance}
          </h2>

          <button
            onClick={() => setShowWithdrawModal(true)}
            className="mt-4 bg-blue-200 text-black px-4 py-2 rounded font-semibold hover:bg-gray-100"
          >
            Withdraw
          </button>
        </div>

        {/* CREDIT */}
        <div className="bg-white p-6 rounded-xl shadow">
          <p className="text-gray-500">Total Credits</p>
          <h2 className="text-2xl font-bold text-green-600 mt-2">
            ₹{walletData.totalCredits}
          </h2>
        </div>

        {/* DEBIT */}
        <div className="bg-white p-6 rounded-xl shadow">
          <p className="text-gray-500">Total Debits</p>
          <h2 className="text-2xl font-bold text-red-500 mt-2">
            ₹{walletData.totalDebits}
          </h2>
        </div>
      </div>

      {/* TRANSACTION TABLE */}
      <div className="bg-white rounded-xl shadow overflow-hidden">
        <div className="p-4 border-b font-semibold text-lg">
          Transactions History
        </div>

        {walletData.transactions.length === 0 ? (
          <div className="p-6 text-center text-gray-500">
            No transactions found
          </div>
        ) : (
          <div className="overflow-x-auto">
            <table className="w-full text-sm text-center">
              <thead className="bg-gray-100 text-gray-800 text-center">
                <tr>
                  <th className="p-3 text-left">Description</th>
                  <th className="p-3">Type</th>
                  <th className="p-3">Amount</th>
                  <th className="p-3">Date</th>
                </tr>
              </thead>

              <tbody>
                {walletData.transactions.map((item) => (
                  <tr key={item._id} className="border-t hover:bg-gray-50">
                    <td className="p-3">{item.description}</td>

                    <td className="p-3 text-center capitalize">{item.type}</td>

                    <td
                      className={`p-3 text-center font-semibold ${
                        item.type === "credit"
                          ? "text-green-600"
                          : "text-red-500"
                      }`}
                    >
                      ₹{item.amount}
                    </td>

                    <td className="p-3 text-center">
                      {new Date(item.createdAt).toLocaleDateString()}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {showWithdrawModal && (
        <div className="fixed inset-0 bg-gray-900 bg-opacity-40 flex justify-center items-center">
          <div className="bg-white p-6 rounded-lg w-96">
            <h2 className="text-lg font-semibold mb-4">Withdraw Amount</h2>

            <input
              type="number"
              placeholder="Enter amount"
              value={withdrawAmount}
              onChange={(e) => setWithdrawAmount(e.target.value)}
              className="w-full border p-2 rounded mb-3"
            />

            {error && <div className="text-red-500 text-sm mb-2">{error}</div>}

            <div className="flex justify-end gap-2">
              <button
                onClick={() => setShowWithdrawModal(false)}
                className="px-4 py-2 border rounded"
              >
                Cancel
              </button>

              <button
                onClick={handleWithdrawSubmit}
                disabled={withdrawLoading}
                className="px-4 py-2 bg-blue-600 text-white rounded"
              >
                {withdrawLoading ? "Processing..." : "Submit"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ResellerWallet;